module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/InsightFilter1-60c20b47b9c40b47579c90f5e9a4ef2f.jpg";